import { debug } from '../../utils';
import { createAction } from 'redux-actions';
const log = debug('lego:models/utils');

const createProgressActions = (actionName) => ({
    'START': actionName,
    'COMPLETED': actionName+'_COMPLETED',
    'REJECTED': actionName+'_REJECTED',
    'CANCELLED': actionName+'_CANCELLED',
    'CLEAR': actionName+'_CLEAR'
});

const identity = (payload) => payload;

declare var Promise: any;

const createActionCreators = (actions, handlers=({} as any)) => {
    let resolve, reject;
    const creators = {
        start: createAction(actions.START, handlers.START || identity),
        complete: createAction(actions.COMPLETED, (...args) => {
            if (resolve) { resolve(...args); }
            return (handlers.completed || identity)(...args);
        }),
        cancel: createAction(actions.CANCELLED, (...args) => {
            if (reject) { reject(...args); }
            return (handlers.cancelled || identity)(...args);
        }),
        reject: createAction(actions.REJECTED,  (...args) => {
            if (reject) { reject(args); }
            return (handlers.rejected || identity)(...args);
        }),
        clear: createAction(actions.CLEAR,  (...args) => {
            if (reject) { reject(...args); }
            return (handlers.cleared || identity)(...args);
        })
    };

    const initiate = (...args) => (dispatch) => {
        dispatch(creators.start(...args));
        return new Promise((resolver, rejector) => {
            resolve = resolver;
            reject = rejector;
        });
    };
    return Object.assign(initiate, creators, {names: actions});
};

import { Observable as O } from 'rxjs/Observable';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/onErrorResumeNext';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/merge';
import { ajax } from 'rxjs/observable/dom/ajax';

import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import includes from 'lodash/includes';
import isArray from 'lodash/isArray';
const createAsyncRequestEpic = (url, actions, method='getJSON') =>
  action$ => action$.ofType(actions.names.START)
  .mergeMap(({payload, type}) => {
    if (includes(['post', 'postJSON'], method) && !isObject(payload))
      throw `${method} Payload must be an object, was: ` + payload;

		const _url = isFunction(url) ? url(payload) : url;
    const initialPayload = payload;

    // actions.reject = isArray(actions.reject) ? actions.reject : [actions.reject];
    // actions.complete = isArray(actions.complete) ? actions.complete : [actions.complete];

    return ajax[method](_url, payload, {'Content-Type': 'application/json'})
      .flatMap(response => O.from(actions.complete.map(creator => creator(response, initialPayload))))
      .takeUntil(action$.ofType(actions.names.CANCELLED))
		//			.timeout(3000)
      .catch(err => {
				log(`${url} ${method} ajax failed: `, err);
        return O.from(actions.reject.map(creator => creator(payload, err)));//initialPayload, err)));
      });
  })
    // .catch((err ) => {
		//     log(`${url} ${method} epic failed: `, err);
    //     return O.from(actions.reject.map((creator) => creator(err)));
    // });

import { inBrowser } from '../../utils';
function createAjaxEpic(url, actions?, method='getJSON', handler?) {
	if (typeof url === 'object') {
		actions = url.actions
		method = url.method
		handler = url.handler
//		({actions, method, handler}) = url
		url = url.url
	}
 actions.reject = isArray(actions.reject) ? actions.reject : [actions.reject];
 actions.complete = isArray(actions.complete) ? actions.complete : [actions.complete];
 //const epic = createSyncRequestEpic(url, actions, method)
 const ajax = payload => ajaxHandler({payload, url, actions, method})
 //const _handler = __CLIENT__ ? handler || ajax : ajax;
 // return inBrowser() ?
 //   	createAsyncRequestEpic(url, actions, method)
 // 		: createSyncRequestEpic(actions, _handler);

	// return __CLIENT__ ? createAsyncRequestEpic(url, actions, method)
	// 	: createSyncRequestEpic(actions, handler ? handler : ajax);

	const epic = (__CLIENT__ ?
								createAsyncRequestEpic(url, actions, method)
								: createSyncRequestEpic(actions, handler ? handler : ajax))
			return epic
 // return epic.catch(err => {
 // 	log(`${url} ${method} epic failed: `, err);
 //  return O.from(actions.reject.map(creator => creator(err)));
 // });
}

function ajaxHandler({payload, url, method, actions}) {
 if (includes(['post', 'postJSON'], method) && !isObject(payload))
  throw `${method} Payload must be an object, was: ` + payload;
	const _url = isFunction(url) ? url(payload) : url;
	const requestPayload = payload;

 return ajax[method](_url, payload, {'Content-Type': 'application/json'})
		.flatMap(responsePayload =>
						 O.from(actions.complete.map(creator => creator(responsePayload, requestPayload))))
}

const createSyncRequestEpic = (actions, handler) =>
	{console.error(`creating ${actions.names.START} epic`)
	 return (action$, {getState}) => action$.ofType(actions.names.START)
	.mergeMap(({payload, type}) => {
		const initialPayload = payload
		return handler(payload, getState())
			.flatMap(response => { console.log('completed request', actions.names.START)
							 return O.from(actions.complete.map(creator => creator(response, initialPayload)))
													 })
			.takeUntil(action$.ofType(actions.names.CANCELLED))
		  // .timeout(3000)
			.catch(err => {
				const { status, statusText, responseText } = err.xhr
				const { method, url, headers } = err.request
				log(`API failed: `, {
					response: {status, statusText, responseText},
					request: {method, url, headers},
				});

				return O.from(actions.reject.map(creator => creator(payload, err)));
			})})
	.catch(err => {
 		log(`$ {url} $ {method} epic failed: `, err);
		return O.from(actions.reject.map(creator => creator(err)))
	});
	}
export { createAjaxEpic, createProgressActions, createActionCreators };



// WEBPACK FOOTER //
// ./src/app/models/utils.ts